import styled from 'styled-components'
import { breakpoints } from '../../../../../constants'
import {
	MEDIUMORANGE,
	DARKGRAY,
	WHITE,
	INPUTGRAY,
	PLACEHOLDERGRAY,
	RED,
	GRAY
} from '../../../../../styles/colors.style'

export const Container = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px 10px;

	@media (min-width: ${breakpoints.MOBILE}px) {
	}

	.msg-error {
		color: ${RED};
		text-align: center;
		margin-bottom: 10px;
	}
`

export const Header = styled.header`
	padding-bottom: 20px;

	h2 {
		font: 600 22px/28px 'Source Sans Pro';
		text-align: center;
		color: ${DARKGRAY};
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
	}
`

export const Box = styled.div`
	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 500px;
	}
`

export const Text = styled.p`
	font: 14px/18px 'Source Sans Pro';
	text-align: center;
	padding-bottom: 20px;
	color: ${DARKGRAY};

	&.nopadding {
		padding: 0;
	}

	strong {
		font-size: 20px;
	}
`

export const Button = styled.button`
	display: block;
	margin: 0 auto;
	width: 262px;
	height: 45px;
	border-radius: 5px;
	border: 0;
	color: ${WHITE};
	background: ${MEDIUMORANGE};
	font: 600 15px/25px 'Source Sans Pro';
	cursor: pointer;

	&:disabled {
		opacity: 0.5;
		cursor: initial;
	}
`
export const Field = styled.input`
	margin: 0 auto 20px;
	padding: 10px;
	background: ${WHITE};
	width: 90%;
	display: block;
	height: 45px;
	border-radius: 6px;
	border: 1px solid ${INPUTGRAY};
	text-align: center;
	color: ${GRAY};
	box-sizing: border-box;

	&.safari-font-force{
		font-size: 14px !important;
	}

	&:focus {
		outline: none;
	}

	&::-webkit-input-placeholder {
		/* Edge */
		color: ${PLACEHOLDERGRAY};
		font: 16px/45px 'Source Sans Pro';
	}

	&:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: ${PLACEHOLDERGRAY};
		font: 16px/45px 'Source Sans Pro';
	}

	&::placeholder {
		color: ${PLACEHOLDERGRAY};
		font: 16px/45px 'Source Sans Pro';
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 337px;
	}
`
